








import {Component, Prop, Vue} from 'vue-property-decorator';

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog $next Add inline type.
 */
@Component
export default class JdsIcon extends Vue {
    @Prop({type: Boolean, default: false}) inline!: boolean
    @Prop() size!: string
    @Prop({default: 'currentColor'}) color!: string

    get styles() {
        let styles = {}

        if (!this.size) {
            styles = {
                width: '1em',
                height: '1em',
            }
        }

        if (this.inline) {
            styles = { ... styles, ... {
                    'fontSize': '90%',
                    'verticalAlign': 'middle',
                    top: '-1px'
                }}
        }

        return styles
    }
}
